import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { SubscriptionDialogComponent } from '../../shared/components/subscription-dialog/subscription-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionDialogService {
  private dialogRef: DynamicDialogRef | null = null;

  constructor(
    private dialogService: DialogService,
    private router: Router
  ) {}

  showSubscriptionDialog(): void {
    console.log('🚨 SubscriptionDialogService.showSubscriptionDialog() called');
    if (this.dialogRef) {
      console.log('🚨 Dialog already open, returning');
      return; // Dialog already open
    }

    console.log('🚨 Opening dialog...');
    this.dialogRef = this.dialogService.open(SubscriptionDialogComponent, {
      header: 'Subscription Required',
      width: '500px',
      height: 'auto',
      modal: true,
      closable: true,
      data: {
        onSubscribe: () => this.onSubscribe(),
        onCancel: () => this.onCancel()
      }
    });

    this.dialogRef!.onClose.subscribe(() => {
      console.log('🚨 Dialog closed');
      this.dialogRef = null;
    });
    console.log('🚨 Dialog opened successfully');
  }

  private onSubscribe(): void {
    this.closeDialog();
    this.router.navigate(['/subscribe']);
  }

  private onCancel(): void {
    this.closeDialog();
  }

  private closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
